import React from 'react';
import qrImage from 'qr-image';

const QRCode = (props) => {
  const style = props.style || { paddingLeft: 130 };
  const pngBuffer = qrImage.imageSync(props.text, { type: 'png', margin: 1, size: 5 });
  const dataURI = 'data:image/png;base64,'+ pngBuffer.toString('base64');

  return (<img src={dataURI} alt="barcode" style={style} className="qr" />)
}

export default QRCode;


// WEBPACK FOOTER //
// ./src/components/QRCode/index.js